export default "__VITE_ASSET__209fd3a0__"